module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-21.3b397530.jpg";